export default __webpack_public_path__ + "static/media/56_photo.0038d58a.jpg";